export var AT=function(AT){AT["SET_CURRENT_LOCATION"]="SET_CURRENT_LOCATION";AT["RESET_CURRENT_LOCATION"]="RESET_CURRENT_LOCATION";return AT;}({});